import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { HF_FONT_WEIGHTS } from '@root/app/shared/theme/designTokens';

export interface HfEmptyStateProps {
    image: string;
    message: string;
    submessage?: string;
    small?: boolean;
}

const HfEmptyState: React.FC<HfEmptyStateProps> = ({ image, message, submessage, small }) => {
    if (small) {
        return (
            <Stack alignItems='center' textAlign='center' spacing={1}>
                <Box
                    component='img'
                    src={image}
                    alt={message}
                    sx={{ maxHeight: 64, width: 'auto' }}
                />
                <Typography variant='body3' fontWeight={HF_FONT_WEIGHTS.bold}>
                    {message}
                </Typography>
                {submessage && (
                    <Typography variant='body3' color='text.secondary'>
                        {submessage}
                    </Typography>
                )}
            </Stack>
        );
    }

    return (
        <Stack alignItems='center' textAlign='center' spacing={1.5}>
            <Box
                component='img'
                src={image}
                alt={message}
                sx={{ maxHeight: 96, width: 'auto' }}
            />
            <Typography variant='h1'>
                {message}
            </Typography>
            {submessage && (
                <Typography variant='body3'>
                    {submessage}
                </Typography>
            )}
        </Stack>
    );
};

export default HfEmptyState;
